import React, { Fragment, useState } from 'react';
import {
  Button,
  Form,
  Row,
  Col,
  Container,
  Alert,
} from '@themesberg/react-bootstrap';
import { post } from '../../../services/back.service';

function ClaimPlatesForm({ plate, updateReport }) {
  const [alert, setAlert] = useState({ show: false, message: '', type: '' });
  const [infoForm, setForm] = useState({
    type: '',
    date: '',
    value: '',
  });

  const handleForm = ({ target }) => {
    setForm({ ...infoForm, [target.name]: target.value });
  };

  const saveForm = async (e) => {
    e.preventDefault();
    const body = { plate, ...infoForm };
    let respo;
    let msg;

    respo = await post('/critical/claim/', body);
    msg = 'Registro agregado.';

    if (respo.success) {
      setAlert({
        show: true,
        message: msg, //'Registro agregado.',
        type: 'success'
      });

      setForm({
        type: '',
        date: '',
        value: '',
      });
      updateReport()
    } else {
      setAlert({
        show: true,
        message: respo.message,
        type: 'danger'
      });
    }
  };

  return (
    <Fragment>
      <Container>
        {alert.show && <Alert variant={alert.type} onClose={() => setAlert({ show: false })} dismissible>{alert.message}</Alert>}
        <Form id='form_add_log' onSubmit={(e) => saveForm(e)}>
          <Row>
            <Col>
              <Form.Label htmlFor="obs_additonal_1">TIPO</Form.Label>
              <Form.Control
                type='text'
                maxLength={3}
                name="type"
                value={infoForm.type}
                onChange={(e) => handleForm(e)}
                required
              />
            </Col>
            <Col>
              <Form.Label htmlFor="obs_additonal_1">FECHA</Form.Label>
              <Form.Control
                type='date'
                maxLength={3}
                name="date"
                value={infoForm.date}
                onChange={(e) => handleForm(e)}
                required
              />
            </Col>
            <Col>
              <Form.Label htmlFor="obs_additonal_1">VALOR</Form.Label>
              <Form.Control
                type='number'
                min={0}
                name="value"
                value={infoForm.value}
                onChange={(e) => handleForm(e)}
                required
              />
            </Col>
          </Row>
          <Row className="text-center m-3">
            <Col>
              <Button
                type="submit"
                variant="primary"
              >
                Guardar Informacion
              </Button>
            </Col>
          </Row>
        </Form>
      </Container>
    </Fragment>
  );
}

export default ClaimPlatesForm;
